export interface AuthState {
    accessToken: string | null;
    refreshToken: string | null;
    isAuthenticated: boolean;
}

export interface LoginResponse {
    accessToken: string;
    refreshToken: string;
    idToken: string;
}

export interface RefreshResponse {
    accessToken: string;
    refreshToken: string;
    idToken: string;
}

type ClaimMap = Record<string, string>;

export const userClaims: ClaimMap = {
    'name': 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name',
    'id': 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier',
    'expires': 'exp',
    'audience': 'aud',
    'issuer': 'iss'
};

export interface User{
    id: string;
    name: string;
}